import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import amole from "../images/amolebet.png";
import search from "../images/search.svg";
import wallet from "../images/wallet.svg";
import darksearch from "../images/darksearch.svg";
import login from "../images/login.svg";
import Register from "./Register";
import { formatAmount, transformApiData } from "../utils";
import Login from "./Login";
import { useDispatch, useSelector } from "react-redux";
import {
  logout,
  selectLoginModal,
  selectRegisterModal,
  selectResetPasswordModal,
  selectUser,
  setLoginModal,
  setRegisterModal,
  setResetPasswordModal,
} from "../store/auth-slice";
import { History, LogOut, TrendingUp, User } from "lucide-react";
import { DepositModal } from "./DepositModal";
import NotificationIcon from "../screens/Notification/NotificationIcon";
import { socketService } from "../store/socket";
import { SearchComponent } from "./SearchComponent";
import { useGetGamesQuery } from "../store/apis";
import { MobileSearchModal } from "./MobileSearchModal";
import PasswordReset from "./PasswordReset";

const menuItems = [
  // { label: "Sports Betting", path: "/sports" },
  // { label: "Live Betting", path: "/" },
  // { label: "Casino", path: "/casino" },
  // { label: "Jackpots", path: "/" },
  // { label: "Livescore", path: "/" },
  // { label: "Promotions", path: "/" },
];

const Header = () => {
  // Toggle Register / Login Modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const [isModalOpenRGS, setIsModalOpenRGS] = useState(false);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector(selectUser);
  const [depositAmount, setDepositAmount] = useState("");
  const [openDepositModal, setOpenDepositModal] = useState(false);
  const isLoginModalOpen = useSelector(selectLoginModal);
  const isResetPasswordModalOpen = useSelector(selectResetPasswordModal);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data, isLoading } = useGetGamesQuery();
  const [transformedData, setTransformedData] = useState([]);
  const isRegistrationModalOpen = useSelector(selectRegisterModal);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const openModal = () => {
    dispatch(setLoginModal(true));
    setIsModalOpen(true);
  };
  const closeModal = () => {
    dispatch(setLoginModal(false));
    setIsModalOpen(false);
  };
  const openResetPasswordModal = () => {
    dispatch(setResetPasswordModal(true));
  };
  const closeResetPasswordModal = () => {
    dispatch(setResetPasswordModal(false));
  };
  useEffect(() => {
    if (data) {
      const transformedData = transformApiData(data);
      setTransformedData(transformedData);
    }
  }, [data]);
  useEffect(() => {
    if (user && user.id) {
      // Connect to socket when component mounts
      socketService.connect(user.id);

      // Initial balance load
      // dispatch(refreshBalance(provider));
    }

    return () => {
      // Disconnect when component unmounts (or move to App level)
      // socketService.disconnect();
    };
  }, [user]);
  const openModalRGS = () => {
    dispatch(setRegisterModal(true));
    setIsModalOpenRGS(true);
  };
  const closeModalRGS = () => {
    dispatch(setRegisterModal(false));
    setIsModalOpenRGS(false);
  };
  // Logout handler
  const handleLogout = () => {
    dispatch(logout());
  };
  const handleDeposit = () => {
    navigate("/funds");
    // handle deposit
    // setOpenDepositModal(false);
    // setDepositAmount("");
  };
  const [isCollapsed, setIsCollapsed] = useState(false);
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isProfileDropdownOpen && !event.target.closest(".profile-dropdown")) {
        setIsProfileDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isProfileDropdownOpen]);
  useEffect(() => {
    if (isCollapsed) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [isCollapsed]);
  const AuthButtons = ({ isMobile = false }) => {
    if (isAuthenticated) {
      return (
        <>
          {isMobile ? (
            <>
              <button className="bg-yellow border-2 border-transparent hover:border-yellow rounded-sm md:rounded-5px flex gap-1 sm:gap-2 items-center justify-between py-2 px-1 sm:px-2 text-[8px] sm:text-xs font-medium text-darkGreen hover:text-yellow hover:bg-transparent group">
                <UserIcon />
                <span>{formatAmount(user.balance, "ETB", "en-ET")}</span>
              </button>
              {/* DEPOSIT BUTTON */}
              <button
                onClick={handleDeposit}
                className="bg-yellow border-2 border-transparent hover:border-yellow rounded-sm md:rounded-5px flex gap-1 sm:gap-2 items-center justify-between py-2 px-1 sm:px-2 text-[8px] sm:text-xs font-medium text-darkGreen hover:text-yellow hover:bg-transparent group"
              >
                Deposit
              </button>
              <NotificationIcon />
              <div className="relative profile-dropdown">
                <button
                  onClick={() =>
                    setIsProfileDropdownOpen(!isProfileDropdownOpen)
                  }
                  className={`w-fit shadow-inputshadow rounded-sm md:rounded-5px overflow-hidden inline-flex items-center justify-center py-[12px] px-2 text-[8px] sm:text-xs leading-none font-medium transition-all duration-300 bg-buttonGradient bg-no-repeat text-white  hover:text-white hover:bg-buttonGradientHover`}
                >
                  <User className={`text-darkblue dark:text-white size-4`} />
                </button>

                {isProfileDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-56 rounded-lg overflow-hidden shadow-lg z-50 bg-shadeGreen border border-gray-200 dark:border-gray-700 text-white">
                    <div className="py-2">
                      {/* Menu Items */}
                      <div className="px-4 py-3 bg-bluedarkmode flex justify-between items-center">
                        <span className="text-sm font-bold text-white dark:text-white">
                          BALANCE:
                        </span>
                        <span className="text-lg font-semibold text-green-600 dark:text-green-400">
                          {formatAmount(user.balance, "ETB", "en-ET")}
                        </span>
                      </div>
                      <button
                        onClick={() => {
                          navigate("/profile");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm font-bold text-white dark:text-white hover:bg-teal transition-colors duration-150"
                      >
                        <User className="w-4 h-4 mr-3" />
                        MY PROFILE
                      </button>

                      <button
                        onClick={() => {
                          navigate("/ntf");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm font-bold text-white dark:text-white hover:bg-teal transition-colors duration-150"
                      >
                        <History className="w-4 h-4 mr-3" />
                        MESSAGES
                      </button>
                      <button
                        onClick={() => {
                          navigate("/transaction");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm font-bold text-white dark:text-white hover:bg-teal transition-colors duration-150"
                      >
                        <History className="w-4 h-4 mr-3" />
                        TRANSACTION HISTORY
                      </button>

                      <button
                        onClick={() => {
                          navigate("/bet-history");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm font-bold text-white dark:text-white hover:bg-teal transition-colors duration-150"
                      >
                        <TrendingUp className="w-4 h-4 mr-3" />
                        BET HISTORY
                      </button>
                      <button
                        onClick={() => {
                          navigate("/casino-history");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm font-bold text-white dark:text-white hover:bg-teal transition-colors duration-150"
                      >
                        <TrendingUp className="w-4 h-4 mr-3" />
                        CASINO HISTORY
                      </button>

                      {/* Divider */}
                      <div className="my-2 border-t border-gray-200 dark:border-gray-700" />

                      {/* Logout Button */}
                      <button
                        onClick={handleLogout}
                        className="w-full flex items-center px-4 py-2.5 text-sm font-bold text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/10 transition-colors duration-150"
                      >
                        <LogOut className="w-4 h-4 mr-3" />
                        LOGOUT
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              {/* Balance */}
              <button className="bg-yellow border-2 border-transparent hover:border-yellow rounded-sm rounded-5px flex gap-1 items-center justify-between p-1 sm:p-2 text-[8px] sm:text-xs font-medium text-darkGreen hover:text-yellow hover:bg-transparent group">
                <UserIcon />
                <span>{formatAmount(user.balance, "ETB", "en-ET")}</span>
              </button>
              <button
                onClick={handleDeposit}
                className="min-w-[88px] bg-yellow  border-solid border-2 border-transparent rounded-5px inline-flex items-center justify-center p-2 px-2 s18:p-[11px_8px] text-sm s18:text-base !leading-none s18:leading-normal font-medium transition-all duration-300 hover:bg-transparent hover:border-yellow hover:text-yellow"
              >
                DEPOSIT
              </button>
              <NotificationIcon />
              <div className="relative profile-dropdown">
                <button
                  onClick={() =>
                    setIsProfileDropdownOpen(!isProfileDropdownOpen)
                  }
                  className={`w-fit shadow-inputshadow rounded-sm md:rounded-5px overflow-hidden inline-flex items-center justify-center py-[12px] px-2 text-[8px] sm:text-xs leading-none font-medium transition-all duration-300 bg-buttonGradient bg-no-repeat text-white  hover:text-white hover:bg-buttonGradientHover`}
                >
                  <User
                    className={`text-darkblue dark:text-white size-5 s18:size-[26px]`}
                  />
                </button>

                {isProfileDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-56 rounded-lg overflow-hidden shadow-lg z-50 bg-shadeGreen bg-no-repeat text-white">
                    <div className="py-2">
                      {/* Menu Items */}
                      <div className="px-4 py-3 bg-bluedarkmode flex justify-between items-center">
                        <span className="text-sm font-bold text-white dark:text-white">
                          BALANCE:
                        </span>
                        <span className="text-lg font-semibold text-green-600 dark:text-green-400">
                          {formatAmount(user.balance, "ETB", "en-ET")}
                        </span>
                      </div>
                      <button
                        onClick={() => {
                          navigate("/profile");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm font-bold text-white dark:text-white hover:bg-teal transition-colors duration-150"
                      >
                        <User className="w-4 h-4 mr-3" />
                        MY PROFILE
                      </button>

                      <button
                        onClick={() => {
                          navigate("/ntf");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm font-bold text-white dark:text-white hover:bg-teal transition-colors duration-150"
                      >
                        <History className="w-4 h-4 mr-3" />
                        MESSAGES
                      </button>
                      <button
                        onClick={() => {
                          navigate("/transaction");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm font-bold text-white dark:text-white hover:bg-teal transition-colors duration-150"
                      >
                        <History className="w-4 h-4 mr-3" />
                        TRANSACTION HISTORY
                      </button>

                      <button
                        onClick={() => {
                          navigate("/bet-history");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm font-bold text-white dark:text-white hover:bg-teal transition-colors duration-150"
                      >
                        <TrendingUp className="w-4 h-4 mr-3" />
                        BET HISTORY
                      </button>
                      <button
                        onClick={() => {
                          navigate("/casino-history");
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full flex items-center px-4 py-2.5 text-sm font-bold text-white dark:text-white hover:bg-teal transition-colors duration-150"
                      >
                        <TrendingUp className="w-4 h-4 mr-3" />
                        CASINO HISTORY
                      </button>

                      {/* Divider */}
                      <div className="my-2 border-t border-gray-200 dark:border-gray-700" />

                      {/* Logout Button */}
                      <button
                        onClick={handleLogout}
                        className="w-full flex items-center px-4 py-2.5 text-sm font-bold text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/10 transition-colors duration-150"
                      >
                        <LogOut className="w-4 h-4 mr-3" />
                        LOGOUT
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </>
      );
    }
    return (
      <>
        {isMobile ? (
          <>
            {" "}
            {/* join now btn */}
            <button
              onClick={openModalRGS}
              className="bg-yellow border-solid border-2 border-transparent rounded-sm md:rounded-5px py-2 px-1 sm:px-2 text-center text-[8px] sm:text-xs leading-normal font-medium transition-all duration-300 hover:bg-transparent hover:border-yellow hover:text-yellow"
            >
              REGISTER
            </button>
            {/* login btn */}
            <button
              onClick={openModal}
              className="w-fit shadow-inputshadow rounded-sm md:rounded-5px overflow-hidden inline-flex items-center justify-center py-[12px] px-2 text-[8px] sm:text-xs leading-none font-medium transition-all duration-300 bg-buttonGradient bg-no-repeat text-white  hover:text-white hover:bg-buttonGradientHover"
            >
              LOGIN
              {/* <img src={login} alt="search" className="md:hidden w-3 sm:w-4" /> */}
            </button>
          </>
        ) : (
          <>
            {/* large screens guest buttons */}
            <button
              onClick={openModalRGS}
              className="min-w-[88px] bg-yellow  border-solid border-2 border-transparent rounded-5px inline-flex items-center justify-center p-2 px-2 s18:p-[11px_8px] text-sm s18:text-base !leading-none s18:leading-normal font-medium transition-all duration-300 hover:bg-transparent hover:border-yellow hover:text-yellow"
            >
              REGISTER
            </button>
            {/* login btn */}
            <button
              onClick={openModal}
              className="min-w-[88px] shadow-inputshadow border-solid border-2 border-[#1b4334] rounded-5px inline-flex items-center justify-center p-2 px-2 s18:p-[11px_8px] text-sm s18:text-base !leading-none s18:leading-normal font-medium transition-all duration-300 bg-buttonGradient bg-no-repeat text-white hover:text-white hover:border-[#1b4334] hover:bg-buttonGradientHover"
            >
              LOGIN
            </button>
          </>
        )}

        {/* end */}
      </>
    );
  };
  return (
    <>
      <PasswordReset
        isOpen={isResetPasswordModalOpen}
        onClose={closeResetPasswordModal}
      />
      {openDepositModal && (
        <DepositModal
          depositAmount={depositAmount}
          setDepositAmount={setDepositAmount}
          onClose={() => setOpenDepositModal(false)}
          onDeposit={handleDeposit}
        />
      )}
      {/* Mobile search modal */}
      <MobileSearchModal
        isOpen={isMobileSearchOpen}
        onClose={() => setIsMobileSearchOpen(false)}
        data={transformedData}
      />
      <section className="sticky top-0 left-0 right-0 w-full bg-shadeGreen z-50 py-2 md:py-4">
        <div className="flex max-xl:justify-between items-center w-full max-w-[1780px] mx-auto max-sm:px-[15px] px-[30px]">
          <div className="max-420:relative z-[100] flex max-xl:pl-[30px]">
            <Link to="/" className="inline-block">
              <img
                src={amole}
                alt="amole"
                className="object-cover w-16 md:w-[130px] lg:w-[150px]
              s16:w-[180px]"
              />
            </Link>
          </div>
          <div className="max-xl:flex max-md:items-center xl:hidden gap-1 sm:gap-2">
            {/* <span
              className="p-2 md:hidden max-md:flex justify-center items-center bg-white/10 rounded-sm md:rounded-5px w-fit max-sm:h-8 h-fit cursor-pointer"
              onClick={() => setIsMobileSearchOpen(true)}
            >
              <img src={search} alt="search" className="invert w-3 sm:w-4" />
            </span> */}
            {/* search btn */}
            <div className="relative max-md:hidden">
              {/* Replaced the search input with SearchComponent */}
              {/* <div className="relative w-[200px] s16:w-[250px]">
                <SearchComponent
                  data={transformedData}
                  placeholder="Search teams.."
                />
              </div> */}
            </div>
            <AuthButtons isMobile={true} />
          </div>
          {/* big screen links */}
          <div className={`hidden xl:flex justify-between w-full`}>
            <ul className="flex flex-row items-center xl:gap-[18px] s16:gap-[30px] xl:mt-0 mx-auto">
              {menuItems.map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.path}
                    className="text-white text-sm s18:text-base !leading-tight s18:leading-normal font-normal hover:text-yellow transition-all duration-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="flex gap-[10px]">
              {/* search */}
              {/* <div className="relative">
                <input
                  type="search"
                  className="h-full xl:w-[150px] s16:w-full p-[8px_40px_8px_12px] s18:p-[11px_40px_11px_15px] rounded-5px 
                  bg-teal shadow-inputshadow placeholder:text-base placeholder:!leading-none s18: s18:placeholder:leading-normal placeholder:text-white text-white"
                  placeholder="Search.."
                />
                <img
                  src={darksearch}
                  alt="search"
                  className="absolute w-[18px] h-[18px] top-1/2 -translate-y-1/2 right-[15px] z-50"
                />
              </div> */}
              {/* Replaced the search input with SearchComponent */}
              {/* <div className="relative w-[200px] s16:w-[250px]">
                <SearchComponent
                  data={transformedData}
                  placeholder="Search teams.."
                />
              </div> */}
              <AuthButtons isMobile={false} />

              {/* theme btn */}
            </div>
          </div>
          {/* hamburger toggle button */}
          <Hamburger
            toggleCollapse={toggleCollapse}
            isCollapsed={isCollapsed}
          />
        </div>
        {/* small screen menubar */}
        <div className={`${isCollapsed ? "block" : "xl:hidden"}`}>
          <div
            className={`${
              isCollapsed
                ? "top-0 left-0 h-full transition-all duration-500"
                : "top-0 left-[-100%] transition-all duration-500"
            } fixed z-[990] top-0 overflow-auto bg-forestGreen h-full w-full xl:hidden`}
          >
            <div className="h-full w-full flex justify-center">
              <ul className="flex flex-col items-center justify-center gap-5 overflow-auto">
                {menuItems.map((item, index) => (
                  <li key={index}>
                    {/* Native scrolling using hash links */}
                    <Link
                      to={item.path}
                      className="text-white text-sm s18:text-base !leading-tight s18:leading-normal font-normal hover:text-yellow transtition-all duration-300"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
      {!isAuthenticated && (
        <>
          <Login isOpen={isLoginModalOpen} onClose={closeModal} />
          <Register isOpen={isRegistrationModalOpen} onClose={closeModalRGS} />
        </>
      )}
    </>
  );
};

export default Header;

const UserIcon = () => {
  return (
    <img src={wallet} alt="icon" className="w-3 sm:w-4 group-hover:invert" />
  );
};

const Hamburger = ({ toggleCollapse, isCollapsed }) => {
  return (
    <button
      className="rounded absolute z-[999] xl:hidden"
      id="navbar-toggle"
      onClick={toggleCollapse}
    >
      <span
        className={`${
          isCollapsed
            ? "w-[20px] rotate-45 top-[4px] duration-500"
            : "duration-500"
        } relative w-[18px] max-[420px]:h-[2px] h-[3px] rounded-md bg-yellow block mb-1`}
      ></span>
      <span
        className={`${
          isCollapsed ? "hidden" : "duration-500"
        } relative w-6 max-[420px]:h-[2px] h-[3px] rounded-md bg-yellow block mb-1`}
      ></span>
      <span
        className={`${
          isCollapsed
            ? "w-[20px] -rotate-45 -top-[3px] duration-500"
            : "duration-500"
        } relative w-[18px] max-[420px]:h-[2px] h-[3px] rounded-md bg-yellow block`}
      ></span>
    </button>
  );
};
